import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import CourseTile from "./CourseTile";
import { Container, Row, Column } from "../grid";
import PropTypes from "prop-types";
import React, { Component } from "react";

const styles = StyleSheet.create({
	container: {
		backgroundColor: colors.white,
		minHeight: 400,
		paddingTop: 20,
	},
});

export default class CoursesContainer extends Component {
	static propTypes = {
		courses: PropTypes.arrayOf(PropTypes.object),
		categoryColors: PropTypes.object,
		showCertificate: PropTypes.func.isRequired,
		updateBookmark: PropTypes.func,
		categoryClicked: PropTypes.func,
		language: PropTypes.string.isRequired,
		// filter: PropTypes.string.isRequired,
	};

	_color = course => {
		return this.props.categoryColors && course.primaryCategoryName
			? this.props.categoryColors[
					course.primaryCategoryName
						.toLowerCase()
						.replace(/[&/\\#,+()$~%.'":*?<>{}\s’]/g, "")
				]
			: null;
	};

	render() {
		return (
			<Container>
				<Row className={css(styles.container)}>
					{this.props.courses.map(course => (
						<Column
							large={4}
							medium={4}
							small={12}
							key={`${course.certificate ? course.certificate : course.id}`}
						>
							<CourseTile
								course={course}
								color={this._color(course)}
								showCertificate={this.props.showCertificate}
								updateBookmark={this.props.updateBookmark}
								language={this.props.language}
								categoryClicked={this.props.categoryClicked}
							/>
						</Column>
					))}
				</Row>
			</Container>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/CoursesContainer.js